import { useState, useEffect, useRef } from "react";
import { YMInitializer } from "react-yandex-metrika";
import ym from "react-yandex-metrika";

import "./App.scss";
import initialData from "./quest_script.json";
import Layout from "./Game/Layout";
import LoadingScreen from "./Loading/LoadingScreen";

import anykeyNormal from "./assets/buttons/anykeyNormal.png";
import anykeyHover from "./assets/buttons/anykeyHover.png";
import anykeyActive from "./assets/buttons/anykeyActive.png";

import restartNormal from "./assets/buttons/restartNormal.png";
import restartHover from "./assets/buttons/restartHover.png";
import restartActive from "./assets/buttons/restartActive.png";

import learnMoreNormal from "./assets/buttons/learnMoreNormal.png";
import learnMoreHover from "./assets/buttons/learnMoreHover.png";
import learnMoreActive from "./assets/buttons/learnMoreActive.png";

import buttonANormal from "./assets/buttons/buttonANormal.png";
import buttonAHover from "./assets/buttons/buttonAHover.png";
import buttonAActive from "./assets/buttons/buttonAActive.png";

import buttonBNormal from "./assets/buttons/buttonBNormal.png";
import buttonBHover from "./assets/buttons/buttonBHover.png";
import buttonBActive from "./assets/buttons/buttonBActive.png";

const preloadingImages = [
  "/assets/loadingTitle.png",
  "/assets/robotLinePlate1.png",
  "/assets/robotLinePlate2.png",
  "/assets/plates/smallPlateRight.png",
  "/assets/footerBar.png",
  "/assets/footerBar2077.png",
  "/assets/attention.png",
  "/assets/lights/lightsBottom.png",
  "/assets/lights/lightsBottomGlow.png",
  "/assets/lights/lightsRight.png",
  "/assets/lights/lightsRightGlow.png",
  "/assets/lights/lightsTop.png",
  "/assets/lights/lightsTopGlow.png",
  anykeyNormal,
  anykeyHover,
  anykeyActive,
  buttonANormal,
  buttonAHover,
  buttonAActive,
  buttonBNormal,
  buttonBHover,
  buttonBActive,
  "/assets/robot/defaultLeft.png",
  "/assets/robot/defaultRight.png",
  "/assets/robot/happyLeft.png",
  "/assets/robot/happyRight.png",
  "/assets/robot/sadLeft.png",
  "/assets/robot/sadRight.png",
  "/assets/robot/semisadLeft.png",
  "/assets/robot/semisadRight.png",
  "/assets/plates/bigPlateLeft.png",
  "/assets/plates/bigPlateRight.png",
  "/assets/plates/mediumPlateRight.png",
  restartNormal,
  restartHover,
  restartActive,
  learnMoreNormal,
  learnMoreHover,
  learnMoreActive,
];

function App() {
  const [questProgress, setQuestProgress] = useState({
    level: 0,
    score: 20,
    selectedAnswer: null,
    progressBar: [],
  });

  const [endingScreen, setEndingScreen] = useState(false);
  const [loadingScreen, setLoadingScreen] = useState(2021);
  const [startingScreen, setStartingScreen] = useState(false);
  const [slideScoreStatus, setSlideScoreStatus] = useState(false);
  const [robotAnswerStatus, setRobotAnswerStatus] = useState(false);

  const loadingTimer = useRef();
  const robotAnswerTimer = useRef();

  useEffect(() => {
    preloadingImages.forEach((image) => {
      const img = new Image();
      img.src = image;
    });

    loadingTimer.current = setInterval(() => {
      setLoadingScreen((prev) => prev + 1);
    }, 30);
  }, []);

  if (loadingScreen >= 2077) {
    clearTimeout(loadingTimer.current);
    setTimeout(() => {
      setLoadingScreen(false);
      setStartingScreen(true);
    }, 500);
  }

  const levelProgressSetter = () => {
    setQuestProgress((prev) => {
      const newLevel = prev.level + 1;

      if (
        newLevel === 20 ||
        prev.score <= 0 ||
        (prev.selectedAnswer === 0 && initialData[prev.level].id === "11")
      ) {
        setEndingScreen(true);
      }

      return {
        level: newLevel,
        score: prev.score,
        selectedAnswer: prev.selectedAnswer,
        progressBar:
          newLevel === 20 || prev.score < 0
            ? [...prev.progressBar]
            : [...prev.progressBar, true],
      };
    });
  };

  const scoreProgressSetter = (selectedAnswer) => {
    setQuestProgress((prev) => {
      const newScore =
        prev.score + initialData[prev.level].answer[selectedAnswer].score;

      let newProgressBar = prev.progressBar;
      newProgressBar[newProgressBar.length - 1] =
        initialData[prev.level].answer[selectedAnswer].expression ===
          "happyLeft.png" ||
        initialData[prev.level].answer[selectedAnswer].expression ===
          "happyRight.png"
          ? true
          : false;

      return {
        level: prev.level,
        score: newScore,
        selectedAnswer: selectedAnswer,
        progressBar: newProgressBar,
      };
    });
  };

  const answerHandler = (selectedAnswer) => {
    if ([4, 10, 13].includes(questProgress.level)) {
      ym(
        "reachGoal",
        `stage_${questProgress.level + 1}_${selectedAnswer === 0 ? "a" : "b"}`
      );
    }

    scoreProgressSetter(selectedAnswer);
    setSlideScoreStatus(true);
    setTimeout(
      () => {
        setSlideScoreStatus(false);
        setRobotAnswerStatus(true);

        robotAnswerTimer.current = setTimeout(
          () => {
            setRobotAnswerStatus(false);
            levelProgressSetter();
          },
          initialData[questProgress.level].answer[selectedAnswer].robot_line ===
            null
            ? 0
            : ((questProgress.level === 13 && questProgress.selectedAnswer === 1) ? 9000 : 6000)
        );
      },
      initialData[questProgress.level].answer[selectedAnswer].score === 0
        ? 0
        : 1500
    );
  };

  const robotAnswerSkipHandler = () => {
    clearTimeout(robotAnswerTimer.current);
    setRobotAnswerStatus(false);
    levelProgressSetter(questProgress.selectedAnswer);
  };

  const startGameHandler = () => {
    ym("reachGoal", "btn_start");
    setStartingScreen(false);
    setQuestProgress({
      level: 0,
      score: 20,
      progressBar: [true],
    });
  };

  const playAgainHandler = () => {
    ym(
      "reachGoal",
      `restart_${
        questProgress.level === 11 ? "1" : questProgress.score > 0 ? "2" : "3"
      }`
    );
    setQuestProgress({
      level: 0,
      score: 20,
      progressBar: [true],
    });
    setEndingScreen(false);
  };

  return (
    <>
      <YMInitializer accounts={[86928388]} />
      <div className="background">
        <img
          className="background__left"
          src={"../assets/background/backgroundLeft.svg"}
          alt="Left Background Element"
        ></img>
        <img
          className="background__left_2077"
          src={"../assets/background/backgroundLeft2077.svg"}
          alt="Left 2077 Badge"
        ></img>
        <img
          className="background__right"
          src={"../assets/background/backgroundRight.svg"}
          alt="Right Background Element"
        ></img>
        <img
          className="background__right_2077"
          src={"../assets/background/backgroundRight2077.svg"}
          alt="Right 2077 Badge"
        ></img>
        {/* <img
          className="background__snowflake"
          src={"../assets/background/backgroundSnowflakesDesktop.png"}
          alt="Snowflakes"
        ></img>*/}
      </div>
      {loadingScreen && <LoadingScreen currentYear={loadingScreen} />}
      {!loadingScreen && (
        <>
          {/* <div className="background__lights_animation">
            <img
              className="background__lights background__lights_top background__lights_top_glow"
              src={"../assets/lights/lightsTopGlow.png"}
              alt="Top Lights Glow"
            ></img>
            <img
              className="background__lights background__lights_top"
              src={"../assets/lights/lightsTop.png"}
              alt="Top Lights"
            ></img>
            <img
              className={`background__lights background__lights_right background__lights_right_glow ${
                !robotAnswerStatus && "background__lights_right_above"
              }`}
              src={"../assets/lights/lightsRightGlow.png"}
              alt="Right Lights Glow"
            ></img>
            <img
              className={`background__lights background__lights_right ${
                !robotAnswerStatus && "background__lights_right_above"
              }`}
              src={"../assets/lights/lightsRight.png"}
              alt="Right Lights"
            ></img>
          </div>
          <img
            className="background__snowflake_mobile_top"
            src={"../assets/background/backgroundSnowflakeMobile.png"}
            alt="Top Snowflake"
          ></img>
          <img
            className="background__snowflake_mobile_bottom"
            src={"../assets/background/backgroundSnowflakeMobile.png"}
            alt="Bottom Snowflake"
          ></img>
          <img
            className="background__snowflake_mobile_right"
            src={"../assets/background/backgroundSnowflakeMobile.png"}
            alt="Right Snowflake"
          ></img>*/}
          <Layout
            currentQuest={initialData[questProgress.level]}
            previousQuest={initialData[questProgress.level - 1]}
            questProgress={questProgress}
            endingScreen={endingScreen}
            startingScreen={startingScreen}
            slideScoreStatus={slideScoreStatus}
            robotAnswerStatus={robotAnswerStatus}
            onRobotAnswerSkip={() => robotAnswerSkipHandler()}
            onStartGame={() => {
              startGameHandler();
            }}
            onClickA={() => answerHandler(0)}
            onClickB={() => answerHandler(1)}
            onPlayAgain={() => playAgainHandler()}
          />
          {/* <img
            className={`background__lights background__lights_bottom background__lights_bottom_glow  ${
              !robotAnswerStatus && "background__lights_bottom_above"
            }`}
            src={"../assets/lights/lightsBottomGlow.png"}
            alt="Bottom Lights Glow"
          ></img>*/}
        </>
      )}
    </>
  );
}

export default App;
